import { Modal } from "antd";
import i18n from "../i18n";

export type CsvErrorPayload = {
  message?: string;
  errorCode?: string;
};

const ERROR_CODE_TRANSLATION_PREFIX = "errorCodes";

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === "object" && value !== null;

const toStringValue = (value: unknown): string | undefined =>
  typeof value === "string" ? value : undefined;

export const parseCsvErrorPayload = async (response: Response): Promise<CsvErrorPayload | undefined> => {
  try {
    const data = await response.clone().json();
    if (!isRecord(data)) return undefined;

    const message = toStringValue(data.message);
    const errorCode = toStringValue(data.error_code);

    if (!message && !errorCode) {
      return undefined;
    }

    return { message, errorCode };
  } catch (_error) {
    console.warn('Failed to parse response')
    return undefined;
  }
};

export const showCsvUploadErrorModal = (
  fileName: string,
  payload?: CsvErrorPayload,
  fallbackMessage?: string
) => {
  const errorCodeTranslationKey = payload?.errorCode ? `${ERROR_CODE_TRANSLATION_PREFIX}.${payload.errorCode}` : null;
  const title = errorCodeTranslationKey && i18n.exists(errorCodeTranslationKey)
    ? i18n.t(errorCodeTranslationKey)
    : fallbackMessage ?? (!i18n.language.startsWith("en") ? payload?.message : undefined) ?? i18n.t("messages.uploadFailed", { fileName });

  Modal.error({
    centered: true,
    title,
  });
};
